var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nx-enum"},[(!_vm.$scopedSlots.default)?[_vm._v(_vm._s(_vm.label))]:_vm._t("default",null,{"options":_vm.options_,"item":_vm.item,"label":_vm.label})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }